/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { doc, getDoc } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase.js';

interface ConstructionModeResult {
  allowed: boolean;
  message?: string;
}

/**
 * Checks if construction mode is active and whether the user should be allowed to proceed
 * @param isAdmin - Whether the current user is an admin
 * @returns Object with allowed boolean and optional message
 */
export const checkConstructionMode = async (isAdmin: boolean): Promise<ConstructionModeResult> => {
  try {
    console.log('🚧 Checking construction mode...');
    
    const underConstructionRef = doc(db, 'system_config', 'under_construction');
    const underConstructionDoc = await getDoc(underConstructionRef);
    
    if (underConstructionDoc.exists()) {
      const constructionData = underConstructionDoc.data();
      console.log('🚧 Construction data:', constructionData);
      
      // If construction mode is active and user is NOT admin, block them
      if (constructionData?.prevent_login && !isAdmin) {
        console.log('🚧 Construction mode active - blocking non-admin login');
        
        // Sign out the user immediately
        await signOut(auth);
        
        return {
          allowed: false,
          message: 'The portal is currently under maintenance. Please try again later.'
        };
      }
    }
    
    console.log('✅ Construction check passed - proceeding with login');
    return { allowed: true };
    
  } catch (error) {
    console.error('Error checking construction mode:', error);
    // On error, allow login to proceed (fail open)
    // You could change this to fail closed if you prefer
    return { allowed: true };
  }
};